import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
const EditSupplyChainLoading = () => {
  let { id } = useParams();

  const [value, setValue] = useState({});
  const [valueContents, setValueContents] = useState([]);
  const [ordersLists, setOrdersLists] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState([]);
  // const [transportSuppliers, setTransportSuppliers] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  const [menu, setMenu] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState('dh');
  const [transitSuppliers, setTransitSuppliers] = useState([]);
  const [permission, setPermission] = useState({});
  let season_id = localStorage.getItem("season_id");


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const formik = useFormik({
    initialValues: {
      id: id,
      season_id: season_id,
      order: value.order_id,
      location: value.location_id,
      // transport_type: value.transport_type,
      transport_supplier: value.transport_supplier,
      transport: value.transport,
      transport_cost: value.transport_cost,
      sous_dum: value.sous_dum,
      //eta_date: value.eta_date,
      loading_status: value.loading_status_id,
      transit_supplier: value.transit_supplier,
      truck_number: value.truck_number,
      temp_tale: value.temp_tale,
      files: valueContents,

      value_in_mad: value.value_in_mad,
      exchange_rate: value.exchange_rate,
      dum: value.dum,
      facture_trans: value.facture_trans,
      facture_Transitaire: value.facture_Transitaire,
      num_expedition_dhl: value.num_expedition_dhl,
      facture_dhl: value.facture_dhl,
      produit: value.produit,
      t1_and_phyto: value.t1_and_phyto,
      numero_du_chauffeur: value.numero_du_chauffeur,
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/supply-chain-loading/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").text("Update Supply Chain Loading");
          //actions.setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
            //actions.resetForm();
            setTimeout(() => {
              window.location.href = "/supplychain-loadings";
            }, 1000);
          }
          else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });


  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  useEffect(() => {
    setPermission(FindModuleById(111));
    console.log(permission);



    axios
      .get(`/helpers/transit-supplier`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let transport_types = response.data.data.supplier;
          let transportlisting = transport_types.map((ord, index) => ({
            label: ord.name,
            value: ord.id,
            key: `supplier-${index}`,
          }));
          setTransitSuppliers(transportlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/supply-chain-loading/edit/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          // toast.error(response.data.data.supply_chain_loading);
          setValue(response.data.data.supply_chain_loading);
          setValueContents(response.data.data.supply_chain_loading.files);
          console.log(response.data.data.supply_chain_loading.order_id);
          let order_id = response.data.data.supply_chain_loading.order_id;

          axios.get(`/orders/listing-produced-delivered-shipped-current/${season_id + '-' + order_id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }).then((response) => {
            if (response.data.code === 200) {
              let orders = response.data.data.orders;

              let orderlisting = orders.map((ord, index) => ({
                label: ord.po_number,
                value: ord.id,
                key: `order-${index}`,
              }));
              setOrdersLists(orderlisting);
            }
          }).catch((error) => {
            console.log(error);
          });


          axios.get(`/helper/currency-by-order/${season_id + '-' + response.data.data.supply_chain_loading.order_id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }).then((response) => {
            if (response.data.code === 200) {
              setCurrencySymbol(response.data.data.customer_currency)
            }
          }).catch((error) => {
            console.log(error);
          });
        }
      })
      .catch((error) => {
        toast.error(error);
      });


    // axios
    //   .get(`/helpers/transport-types`, {
    //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    //   })
    //   .then((response) => {
    //     if (response.data.code === 200) {
    //       let transport_types = response.data.data.transport_types;
    //       let transportlisting = transport_types.map((ord, index) => ({
    //         label: ord.title,
    //         value: ord.id,
    //         key: `trans-${index}`,
    //       }));
    //       setTransportType(transportlisting);
    //     } else {
    //       console.log("API response is not an array");
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // axios
    // .get(`/helpers/transport-supplier`, {
    //   headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    // })
    // .then((response) => {
    //   if (response.data.code === 200) {
    //     let transport_types = response.data.data.supplier;
    //     let transportlisting = transport_types.map((ord, index) => ({
    //       label: ord.name,
    //       value: ord.id,
    //       key: `supplier-${index}`,
    //     }));
    //     setTransportSuppliers(transportlisting);
    //   } else {
    //     console.log("API response is not an array");
    //   }
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
    axios
      .get(`/helpers/loading-status`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let loading_status = response.data.data.loading_status;
          let loadinglisting = loading_status.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `loading-${index}`,
          }));
          setLoadingStatus(loadinglisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;
          let locationslisting = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setLocationLoading(locationslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`/helpers/file-types-logistics`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let types = response.data.data.types;
          let typeslisting = types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setFileTypes(typeslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  const viewFile = (link) => {
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: AWS_DEFAULT_REGION,
      signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = { Bucket: AWS_BUCKET, Key: link };
    return s3.getSignedUrl('getObject', params);
  }

  const getCurrncyByOrder = (event) => {
    const order_id = event.target.value;

    if (order_id != "") {
      setLocationLoading([]);
      axios
        .get(`/supply-chain-loading/get-locations/${order_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              let locations = response.data.data.locations;
              let locationslisting = locations.map((ord, index) => ({
                label: ord.title,
                value: ord.id,
                key: `location-${index}`,
              }));
              setLocationLoading(locationslisting);
            } else {
              console.log("API response is not an array");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });

      axios
        .get(`/supply-chain-loading/get-supplier-cost/${season_id + '-' + order_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              let transport_cost = response.data.data;
              console.log(transport_cost);
              formik.setFieldValue('transport_cost', transport_cost.cost);
            } else {
              console.log("API response is not an array");
            }

          }
        })
        .catch((error) => {
          console.log(error);
        });

    }
  }


  const getFileData = async (event) => {
    const file_link = event.target.files[0];
    const fileName = file_link.name;
    const withoutExtension = fileName.replace(/\.[^.]+$/, '');

    var id_value = event.target.id;
    const ids = id_value.split("-");
    formik.values.files[ids[1]].file_name = withoutExtension;
  }
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Supply Chain Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychain-loadings">
                        Supply Chain Loading
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Supply Chain Loading
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Supply Chain Loading Info</h4>
                    {permission?.update == 1 && (

                      <FormikProvider value={formik}>
                        <form action="#" onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Order</label>
                                {ordersLists.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                                    name="order"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("order", selectedOption);
                                      getCurrncyByOrder(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={ordersLists}
                                    placeholder="Select"

                                  />
                                )}
                                <small>
                                  {backendErrors.order && (
                                    <span className="form-error mt-1">
                                      {backendErrors.order}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Location</label>
                                {locationLoading.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                    name="location"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("location", selectedOption);
                                      //getCurrncyByOrder(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={locationLoading}
                                    placeholder="Select"


                                  />
                                )}
                                <small>
                                  {backendErrors.location && (
                                    <span className="form-error mt-1">
                                      {backendErrors.location}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Transport Cost</label>

                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="transport_cost"
                                    value={formik.values.transport_cost}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Transport Cost" aria-label="Transport Cost" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.transpost_cost && (
                                    <span className="form-error mt-1">
                                      {backendErrors.transpost_cost}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Transit Supplier</label>
                                {transitSuppliers.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={transitSuppliers.find(option => option.value == formik.values.transit_supplier) || null} // Ensure correct format
                                    name="transit_supplier"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("transit_supplier", selectedOption);
                                      //getCurrncyByOrder(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={transitSuppliers}
                                    placeholder="Select"
                                  />
                                )}

                                <small>
                                  {backendErrors.transit_supplier && (
                                    <span className="form-error mt-1">
                                      {backendErrors.transit_supplier}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Sous Dum</label>
                                <input
                                  type="text"
                                  name="sous_dum"
                                  value={formik.values.sous_dum}
                                  className={
                                    backendErrors.sous_dum
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.sous_dum && (
                                    <span className="form-error mt-1">
                                      {backendErrors.sous_dum}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Loading Status</label>
                                {loadingStatus.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={loadingStatus.find(option => option.value == formik.values.loading_status) || null} // Ensure correct format
                                    name="loading_status"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("loading_status", selectedOption);
                                      //getCurrncyByOrder(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={loadingStatus}
                                    placeholder="Select"
                                  />
                                )}
                                <small>
                                  {backendErrors.loading_status && (
                                    <span className="form-error mt-1">
                                      {backendErrors.loading_status}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Temp Tale</label>
                                <input
                                  type="text"
                                  name="temp_tale"
                                  value={formik.values.temp_tale}
                                  className={
                                    backendErrors.temp_tale
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.temp_tale && (
                                    <span className="form-error mt-1">
                                      {backendErrors.temp_tale}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Value in MAD</label>
                                <input
                                  type="text"
                                  name="value_in_mad"
                                  value={formik.values.value_in_mad}
                                  className={
                                    backendErrors.value_in_mad
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Exchange Rate</label>
                                <input
                                  type="text"
                                  name="exchange_rate"
                                  value={formik.values.exchange_rate}
                                  className={
                                    backendErrors.exchange_rate
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Dum</label>
                                <input
                                  type="text"
                                  name="dum"
                                  value={formik.values.dum}
                                  className={
                                    backendErrors.dum
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Facture Trans</label>
                                <input
                                  type="text"
                                  name="facture_trans"
                                  value={formik.values.facture_trans}
                                  className={
                                    backendErrors.facture_trans
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Facture Transitaire</label>
                                <input
                                  type="text"
                                  name="facture_Transitaire"
                                  value={formik.values.facture_Transitaire}
                                  className={
                                    backendErrors.facture_Transitaire
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Num Expédition DHL</label>
                                <input
                                  type="text"
                                  name="num_expedition_dhl"
                                  value={formik.values.num_expedition_dhl}
                                  className={
                                    backendErrors.num_expedition_dhl
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Facture DHL</label>
                                <input
                                  type="text"
                                  name="facture_dhl"
                                  value={formik.values.facture_dhl}
                                  className={
                                    backendErrors.facture_dhl
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Produit</label>
                                <input
                                  type="text"
                                  name="produit"
                                  value={formik.values.produit}
                                  className={
                                    backendErrors.produit
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>T1 and Phyto</label>
                                <input
                                  type="text"
                                  name="t1_and_phyto"
                                  value={formik.values.t1_and_phyto}
                                  className={
                                    backendErrors.t1_and_phyto
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Numero du Chauffeur</label>
                                <input
                                  type="text"
                                  name="numero_du_chauffeur"
                                  value={formik.values.numero_du_chauffeur}
                                  className={
                                    backendErrors.numero_du_chauffeur
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                              </div>
                            </div>

                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Files
                              </h4>
                              {/* <a
                              href="#!"
                              className="btn btn-primary"
                              onClick={handleShow}
                            >
                              +
                            </a> */}
                            </div>
                          </div>
                          <FieldArray
                            name="files"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  // onClick={handleShow}
                                  onClick={() =>
                                    arrayHelpers.push({
                                      file_link: "",
                                      file_name: "",
                                      file_type: "",
                                    })
                                  }
                                >
                                  +
                                </button>
                                <table className="table">
                                  <tbody>
                                    {formik.values.files.map((friend, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="form-group status  pt-3">
                                            <label>Upload File</label><br />

                                            <input
                                              className="form-group"
                                              type="file"
                                              name={`files[${index}].file_link`}
                                              id={`fileupload-${index}`}

                                              onChange={(event) => {
                                                getFileData(event);

                                                const file_link = event.target.files[0];
                                                //console.log("file:", file_link);
                                                //const fileName = file_link.name;
                                                //const fileName = file_link.name;
                                                const reader = new FileReader();

                                                reader.onloadend = () => {
                                                  formik.setFieldValue(
                                                    `files[${index}].file_link`,
                                                    reader.result
                                                  );
                                                };

                                                if (file_link) {
                                                  reader.readAsDataURL(file_link);
                                                }
                                              }}
                                            />
                                            {(formik.values.files[index].link != null) && (
                                              <a
                                                className="btn btn-link"
                                                href={viewFile(formik.values.files[index].link)}
                                                target="_blank"
                                                rel="noreferrer"
                                                download
                                              >
                                                Download
                                              </a>
                                            )}

                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group status">
                                            <label>File Name</label>
                                            <input
                                              type="text"
                                              className="form-input form-control"
                                              name={`files[${index}].file_name`}
                                              id={`filename-${index}`}

                                              value={
                                                formik.values.files[index]
                                                  .file_name
                                              }
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group status">
                                            <label>File Type</label><br />
                                            {fileTypes.length > 0 && (
                                              <Select
                                                name={`files[${index}].file_type`}
                                                options={fileTypes}
                                                value={fileTypes.find(option => option.value == formik.values.files[index].file_type) || null} // Ensure correct format
                                                onChange={(selectedOption) => {
                                                  formik.setFieldValue(`files[${index}].file_type`, selectedOption.value); // ✅ Store only value in Formik
                                                  customHandleInput({
                                                    target: {
                                                      name: `files[${index}].file_type`,
                                                      value: selectedOption.value, // ✅ Ensure only value is passed
                                                    },
                                                  });
                                                }}
                                                onBlur={formik.handleBlur}
                                                placeholder="Select"
                                                className="w-100"
                                              />
                                            )}
                                          </div>
                                        </td>

                                        <td>
                                          <div className="form-group">
                                            <button
                                              className="btn btn-danger"
                                              style={{ marginTop: 30 }}
                                              type="button"
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                            >
                                              -
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />
                          <div className="text-end mt-4">
                            <button type="submit" id="form-submit" className="btn btn-primary" disabled={formik.isSubmitting}>
                              Update Supply Chain Loading
                            </button>
                          </div>
                        </form>
                      </FormikProvider>)}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditSupplyChainLoading;
